// You can write more code here

/* START OF COMPILED CODE */

import BaseScene from "../core/scenes/BaseScene";
import BtnBack from "../core/prefabs/BtnBack";
import UIPositionContainer from "../core/components/UIPositionContainer";
import BtnPause from "../core/prefabs/BtnPause";
import PauseMenu from "../prefabs/PauseMenu";
import EndScreen from "../prefabs/EndScreen";
import BtnAudio from "../core/prefabs/BtnAudio";
import BtnSwitch from "../prefabs/BtnSwitch";
import BtnJump from "../prefabs/BtnJump";
import Scoreboard from "../prefabs/Scoreboard";
import TransitionWorldJungleToCave from "../prefabs/TransitionWorldJungleToCave";
import TransitionWorldShipwreckToJungle from "../prefabs/TransitionWorldShipwreckToJungle";
import LocaliseText from "../core/components/LocaliseText";
/* START-USER-IMPORTS */
import UIButton from '../core/components/UIButton';
import Game from './Game';
import { SceneId, TransitionPoint } from '../rooting';
import { app } from '../core/App';
import { WorldName, WorldNameValues } from '../level/worlds/world';
import { PlayerController } from '../PlayerController';
import { Player } from '../Player';
import { CharacterSkinsValues } from '../CharacterSpine';
import { RelicName, RelicNameValues } from '../level/relics/relic';
import { RunSettingsHandler } from './../level/RunSettingsHandler';
/* END-USER-IMPORTS */

export default class GameUI extends BaseScene {

  constructor() {
    super("GameUI");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // btnBack
    const btnBack = new BtnBack(this, 75, 74.5);
    this.add.existing(btnBack);

    // btnPause
    const btnPause = new BtnPause(this, 1845, 74.5);
    this.add.existing(btnPause);

    // pauseMenu
    const pauseMenu = new PauseMenu(this, 960, 384);
    this.add.existing(pauseMenu);
    pauseMenu.visible = false;

    // endScreen
    const endScreen = new EndScreen(this, 960, 384);
    this.add.existing(endScreen);
    endScreen.visible = false;

    // btnAudio
    const btnAudio = new BtnAudio(this, 1845, 74.5);
    this.add.existing(btnAudio);
    btnAudio.visible = false;

    // btnSwitch
    const btnSwitch = new BtnSwitch(this, 92.5, 671.5);
    this.add.existing(btnSwitch);

    // btnJump
    const btnJump = new BtnJump(this, 1827.5, 671.5);
    this.add.existing(btnJump);

    // scoreboard
    const scoreboard = new Scoreboard(this, 960, 82);
    this.add.existing(scoreboard);

    // transitionWorldJungleToCave
    const transitionWorldJungleToCave = new TransitionWorldJungleToCave(this, 960, 384);
    this.add.existing(transitionWorldJungleToCave);

    // transitionWorldShipwreckToJungle
    const transitionWorldShipwreckToJungle = new TransitionWorldShipwreckToJungle(this, 960, 384);
    this.add.existing(transitionWorldShipwreckToJungle);

    // messageText
    const messageText = this.add.text(960, 177, "", {});
    messageText.setOrigin(0.5, 0);
    messageText.text = "Treasure Collected!";
    messageText.setStyle({ "backgroundColor": "", "color": "#ffffffff", "fontFamily": "ARCO", "fontSize": "60px", "stroke": "#000000ff", "strokeThickness":5,"shadow.stroke":true});

    // btnBack (components)
    const btnBackUIPositionContainer = new UIPositionContainer(btnBack);
    btnBackUIPositionContainer.offsetX = 24;
    btnBackUIPositionContainer.offsetY = 24;
    btnBackUIPositionContainer.PinLeft = true;
    btnBackUIPositionContainer.PinTop = true;

    // btnPause (components)
    const btnPauseUIPositionContainer = new UIPositionContainer(btnPause);
    btnPauseUIPositionContainer.offsetX = 24;
    btnPauseUIPositionContainer.offsetY = 24;
    btnPauseUIPositionContainer.PinRight = true;
    btnPauseUIPositionContainer.PinTop = true;

    // btnAudio (components)
    const btnAudioUIPositionContainer = new UIPositionContainer(btnAudio);
    btnAudioUIPositionContainer.offsetX = 24;
    btnAudioUIPositionContainer.offsetY = 24;
    btnAudioUIPositionContainer.PinRight = true;
    btnAudioUIPositionContainer.PinTop = true;

    // btnSwitch (components)
    const btnSwitchUIPositionContainer = new UIPositionContainer(btnSwitch);
    btnSwitchUIPositionContainer.offsetX = 24;
    btnSwitchUIPositionContainer.offsetY = 24;
    btnSwitchUIPositionContainer.PinLeft = true;
    btnSwitchUIPositionContainer.PinToBottom = true;

    // btnJump (components)
    const btnJumpUIPositionContainer = new UIPositionContainer(btnJump);
    btnJumpUIPositionContainer.offsetX = 24;
    btnJumpUIPositionContainer.offsetY = 24;
    btnJumpUIPositionContainer.PinRight = true;
    btnJumpUIPositionContainer.PinToBottom = true;

    // messageText (components)
    const messageTextLocaliseText = new LocaliseText(messageText);
    messageTextLocaliseText.isDynamic = true;

    this.btnBack = btnBack;
    this.btnPause = btnPause;
    this.pauseMenu = pauseMenu;
    this.endScreen = endScreen;
    this.btnAudio = btnAudio;
    this.btnSwitch = btnSwitch;
    this.btnJump = btnJump;
    this.scoreboard = scoreboard;
    this.transitionWorldJungleToCave = transitionWorldJungleToCave;
    this.transitionWorldShipwreckToJungle = transitionWorldShipwreckToJungle;
    this.messageText = messageText;

    this.events.emit("scene-awake");
  }

  private btnBack!: BtnBack;
  private btnPause!: BtnPause;
  private pauseMenu!: PauseMenu;
  private endScreen!: EndScreen;
  private btnAudio!: BtnAudio;
  private btnSwitch!: BtnSwitch;
  private btnJump!: BtnJump;
  private scoreboard!: Scoreboard;
  private transitionWorldJungleToCave!: TransitionWorldJungleToCave;
  private transitionWorldShipwreckToJungle!: TransitionWorldShipwreckToJungle;
  private messageText!: Phaser.GameObjects.Text;

  /* START-USER-CODE */

  public static events = {
    Back: 'back',
    Home: 'home',
    Map: 'map',
    Replay: 'replay',
    Pause: 'pause'
  } as const;

  private gameScene!: Game;
  private topBtnStartY: number | undefined;
  private bottomBtnStartY: number | undefined;

  public create() {
    this.editorCreate();

    this.gameScene = this.scene.get(SceneId.Game) as Game;
    this.events.on(GameUI.events.Home, this.onHome, this);
    this.events.on(GameUI.events.Map, this.onMap, this);
    this.events.on(GameUI.events.Replay, this.onReplay, this);

    this.btnBack.on(UIButton.events.clicked, this.gameScene.back, this.gameScene);
    this.btnPause.on(UIButton.events.clicked, this.onPause, this);

    this.bindGameEvents();

    this.events.once(Phaser.Scenes.Events.SHUTDOWN, this.shutdown, this);

    // this.hideUI();
    this.hideAudioBtn();

    this.messageText.setVisible(false);
  }

  public showUI() {
    this.tweens.killTweensOf(this.btnBack);
    this.tweens.killTweensOf(this.btnPause);
    this.tweens.killTweensOf(this.scoreboard);

    this.btnBack.visible = true;
    this.btnPause.visible = true;
    this.scoreboard.visible = true;
    this.btnBack.alpha = 0;
    this.btnPause.alpha = 0;
    this.scoreboard.alpha = 0;

    this.add.tween({
      targets: [this.btnBack, this.btnPause, this.scoreboard],
      alpha: 1,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.tweens.killTweensOf(this.btnSwitch);
    this.tweens.killTweensOf(this.btnJump);

    this.btnSwitch.visible = true;
    this.btnJump.visible = true;
    this.btnSwitch.alpha = 0;
    this.btnJump.alpha = 0;

    //this.btnSwitch.input.hitArea.scale *=1.5;
    this.btnSwitch.input.hitArea.setTo(-50, -80, 145 + 100, 145 + 160);

    this.add.tween({
      targets: [this.btnSwitch, this.btnJump],
      alpha: 1,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    console.log(`RELICS ${this.gameScene?.sceneData?.runSettings?.activeRelics}!`);

    if (this.gameScene.sceneData.runSettings?.activeRelics) {
      if (this.gameScene.sceneData.runSettings?.activeRelics.length > 0) {
        this.gameScene?.sceneData?.runSettings?.activeRelics?.forEach((relicName) => {
          this.showRelic(relicName);
        });
      } else {
        this.hideRelic();
      }
    } else {
      this.hideRelic();
    }
  }

  public hideUI() {
    this.add.tween({
      targets: [this.btnBack, this.btnPause, this.scoreboard],
      alpha: 0,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: () => {
        this.btnBack.visible = false;
        this.btnPause.visible = false;
      }
    });

    this.add.tween({
      targets: [this.btnSwitch, this.btnJump],
      alpha: 0,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: () => {
        this.btnBack.visible = false;
        this.btnPause.visible = false;
      }
    });
  }

  public showRelic(relicName: RelicNameValues) {
    this.scoreboard.showRelic(relicName);
  }

  public hideRelic() {
    this.scoreboard.hideRelic();
  }

  public showMessage(message: string) {
    this.messageText.text = message;
    this.messageText.setAlpha(0);
    this.messageText.setVisible(true);
    this.messageText.scale = 0;
    this.add.tween({
      targets: this.messageText,
      alpha: 1,
      scale: 1,
      duration: 400,
      ease: Phaser.Math.Easing.Cubic.Out
    });
  }

  public hideMessage() {
    this.add.tween({
      targets: this.messageText,
      alpha: 0,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: () => {
        this.messageText.setVisible(false);
      }
    });
  }

  public showWorldTransition(worldId: WorldNameValues) {
    if (worldId == WorldName.Jungle) this.transitionWorldShipwreckToJungle.show();
    else if (worldId == WorldName.Cave) this.transitionWorldJungleToCave.show();
    else if (worldId == WorldName.Shipwreck) this.transitionWorldJungleToCave.show();
  }

  public hideWorldTransition(worldId: WorldNameValues) {
    if (worldId == WorldName.Jungle) this.transitionWorldShipwreckToJungle.hide();
    else if (worldId == WorldName.Cave) this.transitionWorldJungleToCave.hide();
    else if (worldId == WorldName.Shipwreck) this.transitionWorldJungleToCave.hide();
  }

  public showAudioBtn() {
    this.btnAudio.visible = true;
    this.btnAudio.alpha = 0;

    this.add.tween({
      targets: [this.btnAudio],
      alpha: 1,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out
    });
  }

  public hideAudioBtn() {
    this.add.tween({
      targets: [this.btnAudio],
      alpha: 0,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: () => {
        this.btnAudio.visible = false;
      }
    });
  }

  public showEndScreen(score: number, highScore: number, activeRelics: RelicNameValues[]) {
    this.endScreen.visible = true;
    this.endScreen.activate(score, highScore, activeRelics);
  }

  public shutdown() {
    this.events.off(GameUI.events.Home, this.onHome, this);
    this.events.off(GameUI.events.Map, this.onMap, this);
    this.events.off(GameUI.events.Replay, this.onReplay, this);

    this.btnBack.off(UIButton.events.clicked, this.gameScene.back, this.gameScene);
    this.btnPause.off(UIButton.events.clicked, this.onPause, this);

    this.unbindGameEvents();

    super.shutdown();
  }

  protected finish() {}

  protected onHome() {
    app.gotoNextScene(this.gameScene, TransitionPoint.GameHome, this.gameScene.sceneData);
  }

  protected onMap() {
    app.gotoNextScene(this.gameScene, TransitionPoint.GameMap, this.gameScene.sceneData);
  }

  protected onReplay() {
    app.gotoNextScene(this.gameScene, TransitionPoint.GameReplay, this.gameScene.sceneData);
  }

  protected onPause() {
    this.topBtnStartY = this.btnBack.y;
    this.add.tween({
      targets: [this.btnBack, this.btnPause],
      y: { from: this.topBtnStartY, to: -100 },
      duration: 600,
      ease: Phaser.Math.Easing.Back.Out
    });

    this.bottomBtnStartY = this.btnSwitch.y;
    this.add.tween({
      targets: [this.btnSwitch, this.btnJump],
      y: { from: this.bottomBtnStartY, to: this.bottomBtnStartY + 200 },
      duration: 600,
      ease: Phaser.Math.Easing.Back.Out
    });

    this.gameScene.pause();

    app.audioHandler.setChannelPause('sfx', true);
    app.audioHandler.setChannelPause('music', true);

    this.pauseMenu.visible = true;
    this.pauseMenu.activate(() => {
      this.onResume();
    });
  }

  protected onResume() {
    this.gameScene.resume();

    app.audioHandler.setChannelPause('sfx', false);
    app.audioHandler.setChannelPause('music', false);

    this.add.tween({
      targets: [this.btnBack, this.btnPause],
      y: { from: -100, to: this.topBtnStartY },
      duration: 600,
      ease: Phaser.Math.Easing.Back.Out
    });

    this.add.tween({
      targets: [this.btnSwitch, this.btnJump],
      y: { from: (this.bottomBtnStartY ?? 0) + 200, to: this.bottomBtnStartY },
      duration: 600,
      ease: Phaser.Math.Easing.Back.Out
    });
  }

  // Pass through all game events we get to the game scene.
  protected bindGameEvents() {
    this.events.on(PlayerController.events.StartJump, () => {
      this.gameScene.events.emit(PlayerController.events.StartJump);
    });

    this.events.on(PlayerController.events.EndJump, () => {
      this.gameScene.events.emit(PlayerController.events.EndJump);
    });

    this.events.on(PlayerController.events.Switch, () => {
      this.gameScene.events.emit(PlayerController.events.Switch);
    });

    this.gameScene.events.on(Player.events.SwitchedCharacter, (character: CharacterSkinsValues) => {
      this.events.emit(Player.events.SwitchedCharacter, character);
    });
  }

  // Clean up any game events we've been passing to the game scene.
  protected unbindGameEvents() {
    this.events.off(PlayerController.events.StartJump);
    this.events.off(PlayerController.events.EndJump);
    this.events.off(PlayerController.events.Switch);
    this.gameScene.events.off(Player.events.SwitchedCharacter);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
